import React, { useState } from "react";
import "../Assets/WebsiteCss/contact.css";
import { FaLocationDot, FaPhone, FaClock, FaWhatsapp } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { IoSend } from "react-icons/io5";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    alert("Thank you for contacting us! We will get back to you soon.");
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-page">
      {/* HERO SECTION */}
      <section className="contact-hero">
        <div className="contact-hero-overlay" />
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Get In Touch</h1>
          <p className="contact-hero-subtitle">
            We'd love to hear from you. Let's bring your vision to life.
          </p>
        </div>
      </section>

      {/* CONTACT INFO CARDS */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="contact-info-card">
            <div className="contact-info-icon">
              <FaLocationDot />
            </div>
            <h3>Visit Us</h3>
            <p>Shalgaon, Tal.: Kadegaon</p>
            <p>Dist.: Sangli, Maharashtra</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <FaPhone />
            </div>
            <h3>Call / WhatsApp</h3>
            <p>
              <a href="tel:+917350135259" className="phone-number">
                +91 73501 35259
              </a>
            </p>
            <p>
              <a
                href="https://api.whatsapp.com/send/?phone=917350135259&text=Hello%2C%20I%20am%20contacting%20from%20your%20RK%20Construction%20website"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <FaWhatsapp
                  style={{ marginRight: "0.3rem", fontSize: "1rem" }}
                />
                Chat on WhatsApp
              </a>
            </p>
            <p
              style={{
                color: "#999",
                fontSize: "0.875rem",
                marginTop: "0.5rem",
              }}
            >
              Mon – Sat: 9:00 AM – 6:00 PM
            </p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <MdEmail />
            </div>
            <h3>Email Us</h3>
            <p>info@rkconstructions.com</p>
            <p>We reply within 24 hours</p>
          </div>

          <div className="contact-info-card">
            <div className="contact-info-icon">
              <FaClock />
            </div>
            <h3>Working Hours</h3>
            <p>Monday - Saturday</p>
            <p>9:00 AM - 6:00 PM</p>
          </div>
        </div>
      </section>

      {/* CONTACT FORM & MAP SECTION */}
      <section className="contact-form-section">
        <div className="contact-form-container">
          {/* LEFT - FORM */}
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <p className="contact-form-subtitle">
              Fill out the form below and we'll get back to you as soon as
              possible.
            </p>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Project inquiry"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project..."
                  rows="6"
                  required
                ></textarea>
              </div>

              <button type="submit" className="contact-submit-btn">
                <IoSend />
                Send Message
              </button>
            </form>
          </div>

          {/* RIGHT - MAP */}
          <div className="contact-map-wrapper">
            <h2 className="contact-map-title">Find Us Here</h2>
            <div className="contact-map-frame">
              <iframe
                title="Company Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.6402571902254!2d74.29774757451054!3d17.381035152989398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc17e7aadbcddf1%3A0x2c6b32e3864b4c33!2sShalgaon%2C%20Maharashtra%20415304!5e0!3m2!1sen!2sin!4v1769075372408!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            <div className="contact-address-box">
              <h3>R K Constructions</h3>
              <p>Shalgaon, Tal.: Kadegaon</p>
              <p>Dist.: Sangli, Maharashtra 415304</p>
              <a
                href="https://www.google.com/maps/place/Shalgaon,+Maharashtra+415304"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-directions-link"
              >
                Get Directions →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CONTACT US SECTION */}
      <section className="contact-why-section">
        <div className="contact-why-container">
          <h2 className="contact-section-title">Why Choose Us?</h2>
          <div className="contact-why-grid">
            <div className="contact-why-item">
              <div className="contact-why-number">01</div>
              <h3>15+ Years of Experience</h3>
              <p>Trusted expertise in construction and design projects</p>
            </div>
            <div className="contact-why-item">
              <div className="contact-why-number">02</div>
              <h3>Quality Assurance</h3>
              <p>Premium materials and meticulous craftsmanship</p>
            </div>
            <div className="contact-why-item">
              <div className="contact-why-number">03</div>
              <h3>On-Time Delivery</h3>
              <p>We respect your timeline and deliver as promised</p>
            </div>
            <div className="contact-why-item">
              <div className="contact-why-number">04</div>
              <h3>24/7 Support</h3>
              <p>Always available to address your concerns</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
